import { guideSteps } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-primary-100 text-primary-800 border border-primary-200">
              <i className="ri-route-line" />
              访问与防走失指南
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              五步养成稳定找到站点的习惯
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              与其记住某一个具体地址，不如建立一套可长期使用的查找习惯。
              下面五个步骤按顺序使用，可以在地址发生变化时依然顺利回到站点。
            </p>

            <div className="mt-7 rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20warm%20workspace%20with%20a%20laptop%20showing%20a%20bookmarks%20list%2C%20amber%20desk%20lamp%20glow%2C%20deep%20teal%20accent%20objects%2C%20clean%20minimal%20composition%2C%20soft%20shadows%2C%20artistic%20editorial%20illustration%2C%20calm%20organized%20mood%2C%20high%20detail&width=800&height=560&seq=dsx-guide-2026&orientation=landscape"
                alt="象征整理收藏与查找路径的书房场景插图"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <ol className="relative">
              {guideSteps.map((s, idx) => (
                <li key={s.step} className="relative flex gap-5 pb-8 last:pb-0">
                  <div className="flex flex-col items-center">
                    <span className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-sm font-bold">
                      {s.step}
                    </span>
                    {idx < guideSteps.length - 1 && (
                      <span className="w-px flex-1 bg-background-300 mt-2" />
                    )}
                  </div>
                  <div className="flex-1 p-5 rounded-lg bg-background-50 border border-background-200">
                    <div className="flex items-center gap-2.5">
                      <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                        <i className={`${s.icon} text-base`} />
                      </span>
                      <h3 className="font-heading text-base font-semibold text-foreground-950">
                        {s.title}
                      </h3>
                    </div>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-700">{s.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}